import { getCorrectEventName } from '../../core/utils'
import TransitionAnimation from '../transition/transition-animation'
import _ from 'lodash'
import { window } from 'ssr-window'

const animationEnd = getCorrectEventName(window, 'animationend')

export default {
  name: 'KCarouselItem',
  props: {},
  data() {
    return {
      index: -1, // update by parent when items update
      animating: false,
      mounted: false,
    }
  },
  computed: {
    active() {
      return this.index === this.$parent.activeIndex
    },
    inactive() { // from active to inactive
      return this.index === this.$parent.prevIndex
    },
    transition() {
      return TransitionAnimation[this.$parent.transition] || TransitionAnimation['moveToLeft']
    },
    animatingOnInit() {
      return this.$parent.animatingOnInit
    },
  },
  watch: {
    active(value) {
      this.animating = value
    },
    mounted() {
      if (this.active && this.$parent.autoHeight) {
        this.$parent.innerHeight = this.$refs.item.getBoundingClientRect().height + 'px'
      }
    },
    inactive(value) {
      if (!this.active) {
        this.animating = value
      }
    },
  },
  mounted() {
    this.mounted = true
  },
  created() {
    this.$parent && this.$parent.updateItems()
  },
  destroyed() {
    this.$parent && this.$parent.updateItems()
  },
  methods: {
    getAnimTransition() {
      const activeIndex = this.$parent.activeIndex
      const prevIndex = this.$parent.prevIndex
      const triggeredByIndicator = this.$parent.triggeredBy === 'indicator'
      const triggeredByControl = this.$parent.triggeredBy === 'control'
      const itemCount = this.$parent.items.length

      let directionReverse = prevIndex > activeIndex
      // 如果是正常循环
      if (!triggeredByIndicator && activeIndex === 0 && (prevIndex + 1 === itemCount)) {
        directionReverse = false
      }

      if (triggeredByControl && activeIndex === itemCount - 1 && prevIndex === 0) {
        directionReverse = true
      }

      if (directionReverse && this.transition.opposite) {
        return TransitionAnimation[this.transition.opposite]
      }

      return this.transition
    },
  },
  render() {
    const style = {}
    const css = {
      'km-carousel__item-wrapper': true,
      'km-carousel__item-wrapper--active': this.active || this.animating,
    }

    if (this.animating) {
      const transition = this.getAnimTransition()
      if (this.active) {
        _.forEach(transition.in.split(/\s+/), activeClass => {
          css[`km-transition-${activeClass}`] = true
        })
      }

      if (this.inactive) {
        _.forEach(transition.out.split(/\s+/), activeClass => {
          css[`km-transition-${activeClass}`] = true
        })
      }
    }

    const attrs = {}

    const events = {
      [`${animationEnd}`]: () => {
        this.animating = false
      },
    }

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      on: events,
    }

    return (
      <div {...data}>
        <div
          ref="item"
          class="km-carousel__item"
        >
          {this.$slots.default}
        </div>
      </div>
    )
  },
}
